module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24vdGljayI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0zNyA5Ljk2ODQzTDM0LjAzMjMgNy4wMDA5OEwxNCAyNi45OTlMNSAxNy45OTk5TDIgMjAuOTk5NkwxNCAzMi45OTg0TDM3IDkuOTY4NDNaIiBmaWxsPSIjNUY5MjBGIi8+CjwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/tick.svg
// module id = QTl7
// module chunks = 0